import React, { useMemo, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from 'prop-types';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getInvoicesNew } from "service/api";

function DatatableTables() {
    const [invoice, setInvoice] = useState([]);

    useEffect(() => {
        getInvoices();
    }, []);

    // const getInvoices = async () => {
    //     try {
    //         const response = await getInvoicesNew();
    //         if (response?.data) {
    //             setInvoice(response.data);
    //         }
    //     } catch (error) {
    //         console.log("Error while fetching data:", error);
    //     }
    // };
    const getInvoices = async () => {
        try {
            const response = await getInvoicesNew();
            if (response?.data) {
                // Create a copy and reverse it
                const reversedData = [...response.data].reverse();
                setInvoice(reversedData);
            }
        } catch (error) {
            console.log("Error while fetching data:", error);
        }
    };
    const columns = useMemo(
        () => [
            {
                Header: '#',
                accessor: (row, index) => index + 1,
                id: 'srno',
            },
            {
                Header: 'Invoice No.',
                accessor: 'invoice_no',
                Cell: ({ value }) => (
                    <span className="fw-bold text-primary">{value || 'N/A'}</span>
                ),
            },
            {
                Header: 'Invoice Type',
                accessor: 'invoice_type',
                Cell: ({ value }) => {
                    const color = value === 'Medical Aid' ? 'success' : value === 'Cash' ? 'warning' : 'info';
                    return <span className={`badge bg-${color}`}>{value || 'N/A'}</span>;
                },
            },
            {
                Header: 'Patient',
                accessor: 'patient_id',
                Cell: ({ value }) => value
                    ? `${value.firstname || ''} ${value.lastname || ''}`
                    : <span className="text-muted">N/A</span>,
            },
            {
                Header: 'Service Date',
                accessor: 'service_date',
                Cell: ({ value }) => value
                    ? new Date(value).toLocaleDateString('en-ZA')
                    : <span className="text-muted">N/A</span>,
            },
            {
                Header: 'Treating Provider',
                accessor: 'treating_provider',
                Cell: ({ value }) => value || <span className="text-muted">N/A</span>,
            },
            {
                Header: 'Total (R)',
                accessor: 'total_amount',
                Cell: ({ value }) => (
                    <span className="fw-bold text-success">R {value || '0.00'}</span>
                ),
            },
            {
                Header: 'Created',
                accessor: 'createdAt',
                Cell: ({ value }) => value
                    ? new Date(value).toLocaleDateString('en-ZA')
                    : 'N/A',
            },
            {
                Header: "Action",
                Cell: ({ row }) => {
                    const id = row.original._id;
                    return (
                        <div className="d-flex">
                            <Link
                                className="btn btn-success btn-sm mx-1"
                                to={`/view/invoice/${id}`}
                                title="View Invoice"
                            >
                                <i className="mdi mdi-eye font-size-14"></i>
                            </Link>
                            <button
                                className="btn btn-danger btn-sm mx-1"
                                title="Delete"
                            >
                                <i className="mdi mdi-trash-can font-size-14"></i>
                            </button>
                        </div>
                    );
                },
            },
        ],
        []
    );

    document.title = "Invoice List";

    return (
        <div className="page-content">
            <div className="container-fluid">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="text-danger fw-bold mb-0">Invoice List</h4>
                    <Link to="/accounts" className="btn btn-primary">
                        <i className="mdi mdi-plus me-1"></i> Create Invoice
                    </Link>
                </div>
                <Breadcrumbs title="Invoice" breadcrumbItem="List" />
                <TableContainer
                    columns={columns}
                    data={invoice}
                    isGlobalFilter={true}
                    isAddOptions={false}
                    customPageSize={10}
                    className="custom-header-css"
                />
            </div>
        </div>
    );
}

DatatableTables.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default DatatableTables;
